export const TABLE_SETTINGS_KEY = 'deleteRelatedDocsModalTableSettings';
export const ORGANIZATION_RELATED_DOCS_BY_DOC_ID_QUERY_KEY = 'org_related_docs_by_doc_id';
